import Actions from '../../odata/actions';

const actions = new Actions('medicalDeviceRiskClass', 'medicalDeviceRiskClasses');

export default actions;
